<template>
  <div class="container">
    <div class="container-header-title">
      <div style="margin-left: 60px">姓名：张晓宇</div>
      <div>年龄：12岁</div>
      <div>性别：男</div>
      <div style="margin-right: 120px">检测时间：2024-11-17 14:56:51</div>
    </div>
    <div class="container-content">
      <div
        class="content-item-box"
        v-for="item in somatizationList"
        :key="item.id"
      >
        <div class="content-item">
          <div class="titleAfter">{{ item.title }}</div>
          <div class="content-title">分析结果：{{ item.analysis }}</div>
          <div class="content-progress">
            <div class="progress-bar">
              <div
                class="normal"
                @mouseenter="handleMouseEnter(item.id, 'normal')"
                @mouseleave="handleMouseLeave(item.id, 'normal')"
              ></div>
              <div class="normal_hover" v-if="hoverState[item.id]?.normal">
                正常
              </div>
              <div
                class="mild"
                @mouseenter="handleMouseEnter(item.id, 'mild')"
                @mouseleave="handleMouseLeave(item.id, 'mild')"
              ></div>
              <div class="mild_hover" v-if="hoverState[item.id]?.mild">
                轻微
              </div>

              <div
                class="moderate"
                @mouseenter="handleMouseEnter(item.id, 'moderate')"
                @mouseleave="handleMouseLeave(item.id, 'moderate')"
              ></div>
              <div class="moderate_hover" v-if="hoverState[item.id]?.moderate">
                中等
              </div>
              <div
                class="severe"
                @mouseenter="handleMouseEnter(item.id, 'severe')"
                @mouseleave="handleMouseLeave(item.id, 'severe')"
              ></div>
              <div class="severe_hover" v-if="hoverState[item.id]?.severe">
                偏重
              </div>
              <div
                class="critical"
                @mouseenter="handleMouseEnter(item.id, 'severe')"
                @mouseleave="handleMouseLeave(item.id, 'severe')"
              ></div>
              <div class="critical_hover" v-if="hoverState[item.id]?.critical">
                严重
              </div>
            </div>
            <div class="progress-text-box">
              <div class="progress-text">正常</div>
              <div class="progress-text">轻微</div>
              <div class="progress-text">中等</div>
              <div class="progress-text">偏重</div>
              <div class="progress-text">严重</div>
            </div>
          </div>
          <div class="content-info">
            {{ item.info }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

// 定义一个对象来存储每个列表项的 hover 状态
const hoverState = ref({});

// 数据循环
const somatizationList = ref([
  {
    id: 1,
    title: "躯体化",
    analysis: "正常",
    info: "该因子主要反映被试身体不适感，包括心血管、胃肠道、呼吸和其他系统的主诉不适，和头痛、背痛、肌肉酸痛,以及焦虑的其他躯体表现。",
  },
  {
    id: 2,
    title: "强迫症状",
    analysis: "正常",
    info: "该因子主要反映被试身体不适感，包括心血管、胃肠道、呼吸和其他系统的主诉不适，和头痛、背痛、肌肉酸痛,以及焦虑的其他躯体表现。",
  },
  {
    id: 3,
    title: "人际关系敏感",
    analysis: "正常",
    info: "该因子主要反映被试身体不适感，包括心血管、胃肠道、呼吸和其他系统的主诉不适，和头痛、背痛、肌肉酸痛,以及焦虑的其他躯体表现。",
  },
  {
    id: 4,
    title: "抑郁",
    analysis: "正常",
    info: "该因子主要反映被试身体不适感，包括心血管、胃肠道、呼吸和其他系统的主诉不适，和头痛、背痛、肌肉酸痛,以及焦虑的其他躯体表现。",
  },
  {
    id: 5,
    title: "焦虑",
    analysis: "正常",
    info: "该因子主要反映被试身体不适感，包括心血管、胃肠道、呼吸和其他系统的主诉不适，和头痛、背痛、肌肉酸痛,以及焦虑的其他躯体表现。",
  },
  {
    id: 6,
    title: "敌对",
    analysis: "正常",
    info: "该因子主要反映被试身体不适感，包括心血管、胃肠道、呼吸和其他系统的主诉不适，和头痛、背痛、肌肉酸痛,以及焦虑的其他躯体表现。",
  },
  {
    id: 7,
    title: "偏执",
    analysis: "正常",
    info: "该因子主要反映被试身体不适感，包括心血管、胃肠道、呼吸和其他系统的主诉不适，和头痛、背痛、肌肉酸痛,以及焦虑的其他躯体表现。",
  },
  {
    id: 8,
    title: "恐怖",
    analysis: "正常",
    info: "该因子主要反映被试身体不适感，包括心血管、胃肠道、呼吸和其他系统的主诉不适，和头痛、背痛、肌肉酸痛,以及焦虑的其他躯体表现。",
  },
  {
    id: 9,
    title: "精神病性",
    analysis: "正常",
    info: "该因子主要反映被试身体不适感，包括心血管、胃肠道、呼吸和其他系统的主诉不适，和头痛、背痛、肌肉酸痛,以及焦虑的其他躯体表现。",
  },
  {
    id: 10,
    title: "其他项目",
    analysis: "正常",
    info: "该因子主要反映被试身体不适感，包括心血管、胃肠道、呼吸和其他系统的主诉不适，和头痛、背痛、肌肉酸痛,以及焦虑的其他躯体表现。",
  },
]);
// 设置鼠标移入和移出事件的方法
const handleMouseEnter = (id, type) => {
  if (!hoverState.value[id]) hoverState.value[id] = {};
  hoverState.value[id][type] = true;
};

const handleMouseLeave = (id, type) => {
  if (hoverState.value[id]) hoverState.value[id][type] = false;
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  overflow-x: scroll;
  .container-header-title {
    background: url("@/assets/svgs/zonghe.png") no-repeat center;
    background-size: cover;
    color: #4aefff;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .container-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .content-item-box {
    }
    .content-item {
      padding: 20px;
      box-sizing: border-box;
      margin-bottom: 20px;
      background-image: url("@/assets/svgs/zonghe2bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .titleAfter {
        position: relative;
        font-weight: bold;
        color: #4aefff;
        margin-bottom: 20px;
      }
      .titleAfter::after {
        content: "";
        position: absolute;
        left: -8px;
        top: 2px;
        width: 3px;
        height: 14px;
        background: #4aefff;
        border-radius: 38px 38px 38px 38px;
      }
      .content-title {
        position: relative;
        color: #6cc6f3;
        padding-left: 10px;
        margin-bottom: 20px;
      }
      .content-title::after {
        content: "";
        position: absolute;
        left: -4px;
        top: 4px;
        width: 10px;
        height: 10px;
        background: #ff6a54;
        border-radius: 50%;
      }
      .content-progress {
        .progress-bar {
          display: flex;
          align-items: flex-end;
          justify-content: center;
          padding: 10px;
          box-sizing: border-box;
          position: relative;
          z-index: 0;
          .normal {
            width: 130px;
            height: 20px;
            color: #fff;
            background: #1a9efe;
            clip-path: polygon(0% 35%, 100% 0%, 100% 100%, 0% 100%);
            border-top-left-radius: 50px;
            border-bottom-left-radius: 10px;
            margin-right: 7px;
          }
          .normal_hover {
            width: 100px;
            background: #1a9efe;
            color: #fff;
            text-align: center;
            height: 25px;
            line-height: 25px;
            border-radius: 15px;
            position: absolute;
            top: 20px;
            left: 20px;
            z-index: 100;
          }
          .normal_hover::after {
            content: "";
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 10px 10px 0 10px;
            border-color: #1a9efe transparent transparent transparent;
            position: absolute;
            left: 40px;
            bottom: -9px;
          }

          .mild {
            width: 150px;
            height: 30px;
            color: #fff;
            clip-path: polygon(0% 35%, 100% 0%, 100% 100%, 0% 100%);
            margin-right: 7px;
            background: #3ac97b;
          }
          .mild_hover {
            width: 100px;
            background: #3ac97b;
            color: #fff;
            text-align: center;
            height: 25px;
            line-height: 25px;
            border-radius: 15px;
            position: absolute;
            top: 20px;
            left: 180px;
            z-index: 100;
          }
          .mild_hover::after {
            content: "";
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 10px 10px 0 10px;
            border-color: #3ac97b transparent transparent transparent;
            position: absolute;
            left: 40px;
            bottom: -9px;
          }

          .moderate {
            width: 150px;
            height: 45px;
            color: #fff;
            clip-path: polygon(0% 35%, 100% 15%, 100% 100%, 0% 100%);
            margin-right: 7px;
            background: #fdc631;
          }
          .moderate_hover {
            width: 100px;
            background: #fdc631;
            color: #fff;
            text-align: center;
            height: 25px;
            line-height: 25px;
            border-radius: 15px;
            position: absolute;
            top: 10px;
            left: 320px;
            z-index: 100;
          }
          .moderate_hover::after {
            content: "";
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 10px 10px 0 10px;
            border-color: #fdc631 transparent transparent transparent;
            position: absolute;
            left: 40px;
            bottom: -9.75px;
          }

          .severe {
            width: 150px;
            height: 58px;
            color: #fff;
            clip-path: polygon(0% 35%, 100% 15%, 100% 100%, 0% 100%);
            margin-right: 7px;
            background: #ff9e5a;
          }
          .severe_hover {
            width: 100px;
            background: #ff9e5a;
            color: #fff;
            text-align: center;
            height: 25px;
            line-height: 25px;
            border-radius: 15px;
            position: absolute;
            top: 0px;
            right: 200px;
            z-index: 100;
          }
          .severe_hover::after {
            content: "";
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 10px 10px 0 10px;
            border-color: #ff9e5a transparent transparent transparent;
            position: absolute;
            left: 40px;
            bottom: -9.75px;
          }
          .critical {
            width: 150px;
            height: 75px;
            color: #fff;
            clip-path: polygon(0% 35%, 100% 25%, 100% 100%, 0% 100%);
            margin-right: 7px;
            background: #ff8291;
          }
          .critical_hover {
            width: 100px;
            background: #ff8291;
            color: #fff;
            text-align: center;
            height: 25px;
            line-height: 25px;
            border-radius: 15px;
            position: absolute;
            top: -4px;
            right: 30px;
            z-index: 100;
          }
          .critical_hover::after {
            content: "";
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 10px 10px 0 10px;
            border-color: #ff8291 transparent transparent transparent;
            position: absolute;
            left: 40px;
            bottom: -9.75px;
          }
        }
      }
      .progress-text-box {
        margin-top: 6px;
        display: flex;
        color: #6cc6f3;
        .progress-text {
          width: 150px;
          text-align: center;
        }
      }
      .content-info {
        color: #6cc6f3;
        width: 750px;
        margin: 20px 0;
        box-sizing: border-box;
        padding-left: 20px;
        line-height: 30px;
      }
    }
  }
}
</style>
